import { createContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { SimpleDataCacheService } from '@/lib/utils/simple-data-cache-service';
import { sortArchaeologyByBook } from './archaeology-by-book-data-service';

interface ArchaeologyByBookDataContextType {
  archaeologyByBook: ArchaeologyByBook[];
  getArchaeologyByBookByBook: (book: string) => ArchaeologyByBook | undefined;
}

export const ArchaeologyByBookDataContext = createContext<ArchaeologyByBookDataContextType | undefined>(undefined);

interface ArchaeologyByBookDataProviderProps {
  children: ReactNode;
  archaeologyByBook: ArchaeologyByBook[];
}

export function ArchaeologyByBookDataProvider({ children, archaeologyByBook: initialData }: ArchaeologyByBookDataProviderProps) {
  const [cacheService] = useState(() => 
    new SimpleDataCacheService<ArchaeologyByBook>(
      initialData,
      sortArchaeologyByBook
    )
  );

  useEffect(() => {
    cacheService.setNewItems(initialData);
  }, [initialData, cacheService]);

  const getArchaeologyByBookByBook = (book: string): ArchaeologyByBook | undefined => {
    return cacheService.getItems().find(item => item.book === book);
  };

  return (
    <ArchaeologyByBookDataContext.Provider
      value={{
        archaeologyByBook: cacheService.getItems(),
        getArchaeologyByBookByBook
      }}
    >
      {children}
    </ArchaeologyByBookDataContext.Provider>
  );
}

